import { PageHeader } from 'app/shared/components/generic-ui/PageHeader';
import { useRouteParams } from 'app/shared/hooks/useRouteParams';
import {
  Pages,
  TabIds,
} from 'app/shared/components/layout/TabNavigation/TabNavigation.types';

import { SuppliersReport } from './SuppliersReport';
import { HealthCheck } from './HealthCheck/HealthCheck';

export const Report = () => {
  const { tab }: { tab: string } = useRouteParams();

  return (
    <PageHeader header={'Reports'} withActions={false} pageType={Pages.REPORT}>
      {tab === TabIds.SUPPLIER_REPORT ? <SuppliersReport /> : <HealthCheck />}
    </PageHeader>
  );
};
